<template>
  <div>
    <a-card title="农药手册">
      <a-row gutter="16">
        <a-col :span="24" style="max-width: 220px; margin-bottom: 12px;">
          <a-input v-model="searchForm.search" placeholder="名称/成分/防治对象" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="max-width: 140px; margin-bottom: 12px;">
          <a-select v-model="searchForm.crop" allowClear placeholder="作物" style="width: 100%" @change="search">
            <a-select-option v-for="o in cropOptions" :key="o.value" :value="o.value">{{ o.label }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24" style="max-width: 140px; margin-bottom: 12px;">
          <a-select v-model="searchForm.category" allowClear placeholder="类型" style="width: 100%" @change="search">
            <a-select-option v-for="o in categoryOptions" :key="o.value" :value="o.value">{{ o.label }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24" style="max-width: 160px; margin-bottom: 12px;">
          <a-select v-model="searchForm.growth_stage" allowClear placeholder="生育期" style="width: 100%" @change="search">
            <a-select-option v-for="o in stageOptions" :key="o.value" :value="o.value">{{ o.label }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px;">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>
        <div style="margin-bottom: 12px; float: right;">
          <a-button type="primary" icon="plus" style="margin: 0 8px;" @click="openFormModal({})">新增药剂</a-button>
        </div>
      </a-row>

      <a-row style="margin-top: 12px;">
        <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading" :pagination="pagination"
          @change="tableChange">
          <div slot="effect_tags" slot-scope="value">
            <a-tag v-for="t in (value || [])" :key="t" color="blue">{{ t }}</a-tag>
          </div>
          <div slot="is_active" slot-scope="value">
            <a-tag :color="value ? 'green' : 'red'">{{ value ? '启用' : '停用' }}</a-tag>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button icon="edit" size="small" @click="openFormModal(item)">编辑</a-button>
              <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
                <a-button type="danger" icon="delete" size="small">删除</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
    <form-modal
      v-model="visible"
      :form="targetItem"
      :cropOptions="cropOptions"
      :categoryOptions="categoryOptions"
      :stageOptions="stageOptions"
      :tagSuggestions="tagSuggestions"
      @create="list"
      @update="list"
    />
  </div>
</template>

<script>
import { pesticideList, pesticideDestroy, pesticideMeta } from '@/api/plantProtect'

export default {
  name: 'Pesticide',
  components: {
    FormModal: () => import('./FormModal.vue'),
  },
  data() {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          customRender: (value, item, index) => index + 1,
          width: 50,
        },
        { title: '商品名称', dataIndex: 'name' },
        { title: '通用名', dataIndex: 'common_name' },
        { title: '作物', dataIndex: 'crop_display', width: 100 },
        { title: '类型', dataIndex: 'category_display', width: 90 },
        { title: '有效成分及含量', dataIndex: 'active_ingredient' },
        { title: '功效特点', dataIndex: 'effect_tags', scopedSlots: { customRender: 'effect_tags' } },
        { title: '防治对象', dataIndex: 'target' },
        { title: '状态', dataIndex: 'is_active', scopedSlots: { customRender: 'is_active' }, width: 70 },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 156 },
      ],
      searchForm: { search: '', crop: undefined, category: undefined, growth_stage: undefined, page: 1, page_size: 16 },
      pagination: { current: 1, total: 0, pageSize: 16 },
      loading: false,
      items: [],
      visible: false,
      targetItem: {},
      cropOptions: [],
      categoryOptions: [],
      stageOptions: [],
      tagSuggestions: [],
    }
  },
  methods: {
    initialize() {
      pesticideMeta().then(data => {
        this.cropOptions = data.crops || []
        this.categoryOptions = data.categories || []
        this.stageOptions = data.growth_stages || []
        this.tagSuggestions = data.effect_tag_suggestions || []
      }).catch(() => {})
      this.list()
    },
    list() {
      this.loading = true
      pesticideList(this.searchForm).then(data => {
        this.pagination.total = data.count
        this.items = data.results
      }).finally(() => {
        this.loading = false
      })
    },
    search() {
      this.searchForm.page = 1
      this.pagination.current = 1
      this.list()
    },
    tableChange(pagination) {
      this.pagination = pagination
      this.searchForm.page = pagination.current
      this.searchForm.page_size = pagination.pageSize
      this.list()
    },
    openFormModal(item) {
      this.targetItem = { ...item }
      this.visible = true
    },
    destroy(id) {
      pesticideDestroy({ id }).then(() => {
        this.$message.success('删除成功')
        this.list()
      })
    },
  },
  mounted() {
    this.initialize()
  },
}
</script>
